import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
declare let dataLayer: any;

@Injectable()
export class GoogleAnalyticsService {

  constructor(private authenticationService: AuthenticationService) { }

  public pageNavigated(url: string, isAuthenticated: boolean, customEvent: string) {
    if (url.startsWith('/')) {
      url = url.substring(1);
    }
    const authStatus = isAuthenticated ? 'auth' : 'unauth';
    if (dataLayer) {
      console.log('Page Navigated to - ' + authStatus + ' - ' +  url + ' - ' +  (customEvent ? `/${customEvent}` : '') );
      dataLayer.push({
        'event': 'VirtualPageview',
        'virtualPageURL': `Vpv/${authStatus}/powerOutages/${url}` + (customEvent ? `/${customEvent}` : ''),
        'virtualPageTitle': url
      });
    }
  }

  public emitPageEvent(pageName: string) {
    if (dataLayer && pageName !== '' && pageName !== undefined) {

      const authStatus = this.authenticationService.isAuthenticated() ? 'auth' : 'unauth';

      // GTM DataLayer tagging
      dataLayer.push({
        'event': 'VirtualPageview',
        'virtualPageURL': `Vpv/poweroutages/${pageName}`,
        'virtualPageTitle': pageName
      });
    }
  }

  /**
   * Method to push userID to GA dataLayer
   * @method emitUserId
   * @returns none
   */
  public emitUserId() {
    dataLayer.push({ 'userID': sessionStorage.getItem('encryptedUsername') || '' });
  }
}
